import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadingType from './loadingType';
export default class Placeholder extends Component {
  static propTypes = {
    selectedLoading: PropTypes.string.isRequired,
    changeSelectedLoading: PropTypes.func.isRequired,
  };

  render() {
    const { selectedLoading, changeSelectedLoading } = this.props;
    const { key, value } = loadingType.PLACEHOLDER;
    return (
      <div
        className={`col-md-3 col-lg-3 col-xs-3 col-sm-3 text-center ${selectedLoading === key &&
          'border-2 border-success'}`}
      >
        <div className="card pt-3">
          <div className="drapcode-item">
            <div className="drapcode-col-12">
              <div className="drapcode-row">
                <div className="drapcode-col-12"></div>
                <div className="drapcode-col-6 big"></div>
                <div className="drapcode-col-4 empty big"></div>
                <div className="drapcode-col-2 big"></div>
                <div className="drapcode-col-4"></div>
                <div className="drapcode-col-8 empty"></div>
                <div className="drapcode-col-6"></div>
                <div className="drapcode-col-6 empty"></div>
                <div className="drapcode-col-12"></div>
              </div>
            </div>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                value={key}
                checked={selectedLoading === key}
                onChange={() => changeSelectedLoading(key)}
              />
              {value}
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}
